module.exports = __webpack_public_path__ + "static/media/three-lines-gray.822131cd.svg";